import React, { useEffect, useState } from "react";
import ColonyFullPage from "../components/commons/ColonyFullPage";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import axios from "axios";
import { useParams } from "react-router-dom";

const ColonyItemId = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [service, setService] = useState(null);
    const { id } = useParams();

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        const loadPhoto = async () => {
            const galleryData = await axios.get(
                `https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production/services/${id}`,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    crossDomain: true,
                }
            );
            
            setService(galleryData.data);
        };

        loadPhoto();

        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Colônia de Férias</h1>
                {service && <ColonyFullPage service={service} />}
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default ColonyItemId;
